import { render, staticRenderFns } from "./SoftwareNotes.vue?vue&type=template&id=174b50ac&"
import script from "./SoftwareNotes.vue?vue&type=script&lang=js&"
export * from "./SoftwareNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports